// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__Wu4oG","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2wERZ"};